module.exports = __webpack_public_path__ + "media/images/icons/avatar-2d1145663122df745f89a8a3bf5c4cee.svg";